import type { TourDefinition } from '../types'

export const onboardingTour: TourDefinition = {
  id: 'onboarding',
  title: 'Getting Started',
  description: 'A 2-minute overview of the Vharta Platform essentials.',
  icon: 'Rocket',
  estimatedMinutes: 2,
  steps: [
    {
      element: '[data-tour-id="welcome"]',
      popover: {
        title: 'Welcome to Vharta',
        description: 'Your unified platform for workflow orchestration. This 2-minute tour covers the essentials.',
      },
      aiContext: 'What is the Vharta Platform and what can I do with it?',
    },
    {
      element: '[data-tour-id="sidebar-nav"]',
      popover: {
        title: 'Navigate the Platform',
        // Refreshed 2026-09-22 (build-surfaces Stage 0,
        // BUILD-SURFACES-SIMPLIFICATION-SEP22.md §5) — the old copy named
        // Workflows/Clusters/Dagster/Airflow, which predates the current
        // Build hub (Workflows, Agent Graphs, Agents, Teams, and more),
        // Monitor, and AI hubs. Clusters (BYOK infrastructure) now lives
        // under Infrastructure; Dagster/Airflow are engines a Workflow can
        // target, not their own nav destinations.
        description:
          'Use the sidebar to access Build (Workflows, Agent Graphs, Agents, Teams), Monitor, AI, Governance, and Infrastructure.',
        side: 'right',
      },
      aiContext: 'How is the sidebar navigation organized and how do I find specific features?',
    },
    {
      element: '[data-tour-id="execution-status"]',
      popover: {
        title: 'Monitor Runs',
        description: 'Track pending, queued, running, and completed Workflow runs at a glance.',
      },
      aiContext: 'What do the different run status categories mean and how do I act on them?',
    },
    {
      element: '[data-tour-id="bell-icon"]',
      popover: {
        title: 'Stay Informed',
        description: 'BYOK engine alerts and system events appear here in real-time. The badge shows unread count.',
        side: 'left',
      },
      aiContext: 'What kinds of notifications does Vharta send and how do I configure them?',
    },
    {
      element: '[data-tour-id="tenant-name"]',
      popover: {
        title: 'Your Tenant',
        description: "You're working within this tenant context. All resources and billing are scoped here.",
        side: 'right',
      },
      aiContext: 'What is a tenant in Vharta and how does multi-tenancy affect my resources?',
    },
  ],
}
